import { Reveal } from "./Reveal";
import { BadgeCheck } from "lucide-react";

const BORKAR_IMG = "https://customer-assets-4nw71qhi.emergentagent.net/job_goa-revolution/artifacts/xo2xgpvg_images.jpeg";

const PHOTOS = {
  shavina: "https://customer-assets-7cd3h4nn.emergentagent.net/job_goans-party-hub/artifacts/eik9yrfs_WhatsApp%20Image%202026-09-30%20at%2002.17.26.jpeg",
  vipin: "https://customer-assets-7cd3h4nn.emergentagent.net/job_goans-party-hub/artifacts/b205tsx7_WhatsApp%20Image%202026-09-30%20at%2002.11.59.jpeg",
  melvin: "https://customer-assets-7cd3h4nn.emergentagent.net/job_goans-party-hub/artifacts/6hu5lcyp_WhatsApp%20Image%202026-09-30%20at%2002.11.07.jpeg",
  premanand: "https://customer-assets-7cd3h4nn.emergentagent.net/job_goans-party-hub/artifacts/vxqrsmpf_WhatsApp%20Image%202026-09-30%20at%2002.13.10.jpeg",
  candido: "https://customer-assets-7cd3h4nn.emergentagent.net/job_goans-party-hub/artifacts/uqmr33h5_WhatsApp%20Image%202026-09-30%20at%2002.11.16.jpeg",
  jayandrath: "https://customer-assets-7cd3h4nn.emergentagent.net/job_goans-party-hub/artifacts/xvuhot71_WhatsApp%20Image%202026-09-30%20at%2002.22.17.jpeg",
};

const MEMBERS = [
  { name: "Miss. Shavina S. Naik Shirodkar", role: "President", photo: PHOTOS.shavina },
  { name: "Mr. Vipin V. Naik", role: "Vice President", photo: PHOTOS.vipin },
  { name: "Mr. Melvin M. Da'Silva", role: "General Secretary", photo: PHOTOS.melvin },
  { name: "Mr. Premanand H. Gaude", role: "General Org. Secretary", photo: PHOTOS.premanand },
  { name: "Mr. Jayandrath Padolkar", role: "Secretary", photo: PHOTOS.jayandrath },
  { name: "Mr. Candido C. Correa", role: "Treasurer", photo: PHOTOS.candido },
];

const initials = (name) =>
  name.replace(/^(Miss\.|Mr\.|Mrs\.)\s*/i, "").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const Committee = () => (
  <section id="committee" className="relative py-28 sec-committee overflow-hidden" data-testid="committee-section">
    <div className="absolute top-10 left-1/3 w-[420px] h-[420px] rounded-full bg-yellow-400/5 blur-[130px]" />
    <div className="max-w-7xl mx-auto px-5 lg:px-10 relative">
      <Reveal>
        <p className="eyebrow mb-4">// The Organisation</p>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
          Committee <span className="text-yellow-400">Members</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-[1.1fr_2fr] gap-6 items-stretch">
        <Reveal>
          <div className="agenda-card p-8 h-full flex flex-col items-start" data-testid="committee-featured-card">
            <img
              src={BORKAR_IMG}
              alt="Shri Viresh Borkar"
              className="w-28 h-28 rounded-full object-cover border-2 border-yellow-400"
            />
            <div className="mt-5 flex items-center gap-2">
              <h3 className="font-display font-bold uppercase text-2xl text-white">Shri Viresh Borkar</h3>
              <BadgeCheck className="text-yellow-400 shrink-0" size={20} />
            </div>
            <p className="mt-1 font-mono-rgp text-[11px] uppercase tracking-[0.2em] text-yellow-400">
              National President
            </p>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
              Member of the Goa Legislative Assembly · St. Andre. Elected in 2022, serves
              on seven committees of the Goa Legislative Assembly, including the Public
              Accounts Committee.
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {MEMBERS.map((m, i) => (
            <Reveal key={m.name} delay={(i % 3) * 0.08} className="h-full">
              <div className="agenda-card p-6 h-full flex flex-col items-start" data-testid={`committee-member-${i + 1}`}>
                {m.photo ? (
                  <img src={m.photo} alt={m.name} className="w-20 h-20 rounded-full object-cover object-top border-2 border-yellow-400" />
                ) : (
                  <div className="w-14 h-14 rounded-full bg-yellow-400 text-black font-display font-black text-xl flex items-center justify-center">
                    {initials(m.name)}
                  </div>
                )}
                <p className="mt-4 font-mono-rgp text-[10px] uppercase tracking-[0.2em] text-yellow-400">{m.role}</p>
                <h3 className="mt-1 font-display font-bold uppercase text-lg text-white leading-tight">{m.name}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
